export { createArticleTracking } from "./createArticleTracking";
export type {
  CreateArticleTrackingConfig,
  ArticleTrackingComposer,
} from "./createArticleTracking";

export {
  createArticleScrollDepthTracker,
  calculateVerticalPercentage,
  stripQueryAndFragment,
} from "./modules/ArticleScrollDepthTracker";
export type {
  ArticleScrollDepthTrackerConfig,
  ArticleScrollDepthTracker,
} from "./modules/ArticleScrollDepthTracker";

export {
  createArticleViewSession,
  generateUuid,
} from "./shared/createArticleViewSession";
export type { ArticleViewSession } from "./shared/createArticleViewSession";

export { createArticleOutboundClickTracker } from "./modules/ArticleOutboundClickTracker";
export type {
  ArticleOutboundClickTrackerConfig,
  ArticleOutboundClickTracker,
} from "./modules/ArticleOutboundClickTracker";

export type { DataLayerTransport } from "./shared/pushDataLayerEvent";
